module.exports = __webpack_public_path__ + "src/img/repost.526b4359.svg";